// This is all specific to English, and would need I18n changes.

function pluralize(n: number, word: string) {
  return n === 1 ? word : `${word}s`
}

const minute = 60
const hour = minute * 60
const day = hour * 24

function humanizeDuration(duration: number) {
  let scaled: number
  let word: string

  if (duration < minute * 2) {
    scaled = duration
    word = 'second'
  } else if (duration < hour * 2) {
    scaled = duration / minute
    word = 'minute'
  } else if (duration < day) {
    scaled = duration / hour
    word = 'hour'
  } else {
    scaled = duration / day
    word = 'day'
  }

  return `${Math.floor(scaled)} ${pluralize(scaled, word)}`
}

export { humanizeDuration }
